import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
  get_pinIdAdapter27yg3a7qzsov7 as get_pinIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { list2lpjhmv1d2k19 as list } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SpinInputg1yg8g6z8wv9 as SpinInput } from '../SpinInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SpinInput_InputAdapterClass;
function SpinInput_InputAdapter() {
  if (SpinInput_InputAdapterClass === VOID) {
    class $ {
      s3x(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      i6t(writer, customScalarAdapters, value) {
        writer.k4a('partyId');
        get_partyIdAdapter().t3x(writer, customScalarAdapters, value.h6s_1);
        writer.k4a('playerIds');
        list(get_playerIdAdapter()).p3y(writer, customScalarAdapters, value.i6s_1);
        writer.k4a('pinIds');
        list(get_pinIdAdapter()).p3y(writer, customScalarAdapters, value.j6s_1);
      }
      t3x(writer, customScalarAdapters, value) {
        return this.i6t(writer, customScalarAdapters, value instanceof SpinInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SpinInput_InputAdapter', VOID, VOID, [Adapter()]);
    SpinInput_InputAdapterClass = $;
  }
  return SpinInput_InputAdapterClass;
}
var SpinInput_InputAdapter_instance;
function SpinInput_InputAdapter_getInstance() {
  return SpinInput_InputAdapter_instance;
}
//region block: init
SpinInput_InputAdapter_instance = new (SpinInput_InputAdapter())();
//endregion
//region block: exports
export {
  SpinInput_InputAdapter_instance as SpinInput_InputAdapter_instance3d9t8q9spmgtp,
};
//endregion

//# sourceMappingURL=SpinInput_InputAdapter.mjs.map
